import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap, take } from 'rxjs/operators';

import { environment } from '../../environments/environment';

export const authHttpInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.connect2ApiBaseUrl)) {
    return next(req);
  }

  const oidcSecurityService = inject(OidcSecurityService);

  return oidcSecurityService.getAccessToken().pipe(
    take(1),
    switchMap((accessToken) => {
      if (!accessToken) {
        return next(req);
      }

      return next(req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      }));
    })
  );
};